import { render, staticRenderFns } from "./HandPoseDetection.vue?vue&type=template&id=a4081238&"
import script from "./HandPoseDetection.vue?vue&type=script&lang=js&"
export * from "./HandPoseDetection.vue?vue&type=script&lang=js&"
import style0 from "./HandPoseDetection.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports